




export interface Paginator<T> {
    


    hasNextPage: boolean;
    


    hasPrevPage: boolean;
    


    items: T[];
    



    nextPage(): Promise<Paginator<T>>;
    



    prevPage(): Promise<Paginator<T>>;
}

interface PaginatorState<T> {
    source: (token: string) => Promise<RestPaginator<T>>;
    nextToken: string;
    prevToken: string;
    items: T[];
}





class RestPaginator<T> implements Paginator<T> {
    private readonly state: PaginatorState<T>;

    


    public get hasNextPage(): boolean {
        return !!this.state.nextToken;
    }

    


    public get hasPrevPage(): boolean {
        return !!this.state.prevToken;
    }

    


    public get items(): T[] {
        return this.state.items;
    }

    


    constructor(
        items: T[],
        source: (token: string) => Promise<RestPaginator<T>>,
        prevToken: string,
        nextToken: string
    ) {
        this.state = {
            prevToken,
            nextToken,
            source,
            items
        };
    }

    


    nextPage(): Promise<RestPaginator<T>> {
        return this.hasNextPage ? this.state.source(this.state.nextToken) : Promise.reject(new Error("No next page"));
    }

    


    prevPage(): Promise<RestPaginator<T>> {
        return this.hasPrevPage
            ? this.state.source(this.state.prevToken)
            : Promise.reject(new Error("No previous page"));
    }
}

export { RestPaginator };
